// extracted by mini-css-extract-plugin
module.exports = {"insiderTransactions":"Datablock_InsiderTransactions_insiderTransactions__gQWWp"};